module.exports = __webpack_public_path__ + "img/add-floor-params.35ee2461.svg";